import { camelCase } from 'lodash'
import type { ReadonlyFormErrors } from './form-error'

export const parseFormErrorFromApi = (
  apiFormErrors: Readonly<Record<string, string[]>>
): ReadonlyFormErrors => {
  const result: Record<string, string> = {}
  for (const [key, value] of Object.entries(apiFormErrors)) {
    if (!value[0]) {
      continue
    }
    const camelCaseKey = camelCase(key)
    result[camelCaseKey] = value[0]
  }
  return Object.freeze(result)
}
